import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../app/core/models/generic-models';
import * as accountTypesActions from '../actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const accountTypesFeatureKey = 'accountTypes';

export interface AccountTypesState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: AccountTypesState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(accountTypesActions.fromAccountTypesAction.loadAccountTypes, state => ({ ...state, loading: true, error: null })),
  on(accountTypesActions.fromAccountTypesAction.loadAccountTypesSuccess, (state, { response }) => ({ ...state, loading: false, data: response, error: null })),
  on(accountTypesActions.fromAccountTypesAction.loadAccountTypesFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getAccountTypes = (state: AccountTypesState) => state.data;
export const getAccountTypesLoading = (state: AccountTypesState) => state.loading;
export const getAccountTypesError = (state: AccountTypesState) => state.error;